import { validateCompliance } from "utils";

export const formFields = [

    {
      label: 'Παροχή Συναίνεσης για την επεξεργασία προσωπικών δεδομένων και την άντληση - διασταύρωση στοιχείων από τρίτες πηγές.',
      id: 'terms1',
      name: 'terms1',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση ορθότητας και ακρίβειας των στοιχείων που υπεβλήθησαν.',
      id: 'terms2',
      name: 'terms2',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Απαρέγκλιτη τήρηση στους όρους του Προγράμματος',
      id: 'terms3',
      name: 'terms3',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση υποβολής μίας μόνο αίτησης Χρηματοδότησης ανά ΑΦΜ με ακριβή και αληθή στοιχεία, η οποία να αφορά την κύρια ή τη δευτερεύουσα κατοικία τους.',
      id: 'terms4',
      name: 'terms4',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση συναίνεση του ιδιοκτήτη, εάν η κατοικία είναι ενοικιαζόμενη/παραχωρούμενη.',
      id: 'terms5',
      name: 'terms5',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση εγκατάστασης του επιλέξιμου εξοπλισμού με χρήση της επιταγής του Προγράμματος στην κατοικία που έχει καταγραφεί στην αίτηση Χρηματοδότησης.',
      id: 'terms6',
      name: 'terms6',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση ότι δεν υπάρχει περιορισμός από κανονισμούς λειτουργίας (π.χ. κανονισμός πολυκατοικίας, κανονισμός λειτουργίας κτηρίου κ.λπ.) ή το ισχύον κανονιστικό πλαίσιο στην κατοικία που θα τοποθετηθεί ο επιλέξιμος εξοπλισμός. ',
      id: 'terms7',
      name: 'terms7',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση μη μεταβίβασης της επιταγής προς χρήση από τρίτο πρόσωπο που δεν αφορά την κατοικία η οποία αναγράφεται στην αίτηση Χρηματοδότησης.',
      id: 'terms8',
      name: 'terms8',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαιώνεται ότι δεν έχει ληφθεί χρηματοδότηση στο παρελθόν, ούτε πρόκειται να ληφθεί στο μέλλον, από άλλη δημόσια επιχορήγηση για την αγορά του συγκεκριμένου επιλέξιμου εξοπλισμού. Εξαίρεση αποτελούν οι Δυνητικά Ωφελούμενοι του Προγράμματος «ΑΝΑΚΥΚΛΩΝΩ ΑΛΛΑΖΩ ΘΕΡΜΟΣΙΦΩΝΑ».  Φυσικά πρόσωπα που είχαν αιτηθεί στο Πρόγραμμα «ΑΝΑΚΥΚΛΩΝΩ ΑΛΛΑΖΩ ΘΕΡΜΟΣΙΦΩΝΑ» με εγκεκριμένη αίτηση και μη εξαργυρωμένα Voucher.',
      id: 'terms9',
      name: 'terms9',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Βεβαίωση αποφυγής αθέμιτων πρακτικών και κάθε ενέργεια εκμετάλλευσης των όρων του Προγράμματος, ενδεικτικά μέσω της διενέργειας εικονικών συναλλαγών.',
      id: 'terms10',
      name: 'terms10',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Διατήρηση προς επίδειξη το σύνολο του κατά περίπτωση προβλεπόμενου υλικού τεκμηρίωσης που σχετίζεται με την αγορά (πχ. απόδειξη αγοράς) έως και δύο (2) έτη μετά το τέλος του Προγράμματος.',
      id: 'terms11',
      name: 'terms11',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Αποδοχή να υπαχθούν σε πιθανό προγραμματισμένο επιτόπιο έλεγχο από αρμόδιες ελεγκτικές αρχές μετά από πρότερη συνεννόηση, διευκολύνοντας τα αρμόδια όργανα και παρέχοντας κάθε αναγκαία σχετική πληροφορία.',
      id: 'terms12',
      name: 'terms12',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
  ];